export default "__VITE_ASSET__DwHB2K8y__"